import { Modal } from '@components/modal';
import React from 'react';
import { useTranslation } from 'react-i18next';
import DLPForm from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/components/DLPForm';
import { useDlpForm } from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/components/useDlpForm';
import { DlpProfile } from '@/services/api/dlpSettingsApiArea/types';

interface MakeDlpDialogProps {
  isOpen: boolean;
  onClose(): void;
  onSuccess(profile: DlpProfile): Promise<void>;
}

const MakeDlpDialog = ({ isOpen, onClose, onSuccess }: MakeDlpDialogProps) => {
  const { t } = useTranslation();
  const [form, handleSubmit, servers, addServer, deleteServer, editServer] = useDlpForm();

  const onSubmit = async () => {
    const savedProfile = await handleSubmit();
    if (savedProfile) {
      await onSuccess(savedProfile);
      onClose();
    }
  };

  return (
    <Modal
      size="1000px"
      opened={isOpen}
      title={t('dlp.createIntegration')}
      onClose={onClose}
      scrollAreaComponent={undefined}
      fullScreen={typeof window !== 'undefined' && window.innerWidth < 768}
      styles={{
        body: {
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <DLPForm
        form={form}
        handleSubmit={onSubmit}
        onCancel={onClose}
        servers={servers}
        addServer={addServer}
        deleteServer={deleteServer}
        editServer={editServer}
      />
    </Modal>
  );
};

export default MakeDlpDialog;
